import Vue,{ VNode } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import directives from "./plugins/directive";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import filters from "./plugins/filters";
import lazyload from "vue-lazyload";
import { Base64 } from "js-base64";
import axios from "./config/axios";
let echarts = require('echarts/lib/echarts');
require('echarts/lib/chart/bar');
require('echarts/lib/chart/line');
//引入字体
import "@/assets/font/iconfont.css";
Vue.use(lazyload, {
  preLoad: 1.3,
  error: require("@/assets/images/common/error.jpg"),
  loading: require("@/assets/images/common/loadding.gif")
});

Vue.use(directives);
Vue.use(filters);
Vue.use(Base64);
Vue.use(ElementUI);

Vue.prototype.$axios = axios;
Vue.prototype.$title = "智能零售云平台";
Vue.prototype.$echart = echarts;

Vue.config.productionTip = false;

declare global {
  namespace JSX {
    // tslint:disable no-empty-interface
    interface Element extends VNode {}
    // tslint:disable no-empty-interface
    interface ElementClass extends Vue {}
    interface IntrinsicElements {
      [elem: string]: any;
    }
  }
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
